import { render, staticRenderFns } from "./VisitTypeSelect.vue?vue&type=template&id=0d086117"
import script from "./VisitTypeSelect.vue?vue&type=script&lang=js"
export * from "./VisitTypeSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports